import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/site/ArticleCard";

export default function News() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/articles").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Communiqués</h1>
      <p className="mt-4 text-slate-600 max-w-xl">Informations officielles publiées par l'équipe administrative de l'UAPHARCO.</p>
      {items === null ? <Loader2 className="mt-10 h-8 w-8 animate-spin text-emerald-700" /> : items.length ? (
        <div data-testid="news-list" className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{items.map((a) => <ArticleCard key={a.id} a={a} />)}</div>
      ) : <p data-testid="news-empty" className="mt-10 text-slate-500">Aucun communiqué publié pour le moment.</p>}
    </div>
  );
}
